(function () {
    'use strict';

    angular.module('swif.ui')
    .directive('uploadFile', uploadFile)
    .directive('downloadAttachment', downloadAttachment)
    .directive('swifPrimaryAttachmentActions', swifPrimaryAttachmentActions);

    /**
    * @ngdoc directive
    * @name swif.ui:uploadFile
    * @module swif.ui
    * @restrict A
    * @description handle upload of file on input type file
    * @usage
    * <input type="file" upload-file upload-callback="model._uploadCallback" ng-model="model"/>
    **/
    function uploadFile(AttachmentService) {
        'ngInject';
        return {
            restrict: 'A',
            require: 'ngModel',
            scope: {
                uploadCallback: '=?'
            },

            link: function (scope, element, attrs, ngModel) {
                console.log('Directive uploadFile');
                element.bind('change', function (event) {
                    var I = '<i class="fa fa-refresh fa-spin pull-right"></i>';
                    element.parent().append(I);
                    var size = AttachmentService.checkFileSize(event.target.files)
                    if(size === true){
                        AttachmentService.uploadFiles(event.target.files, ngModel.$viewValue)
                        .then(function () {
                            AttachmentService.getAttachments(ngModel.$viewValue)
                            .then(function (data) {
                                element.parent().find('i').remove();
                                ngModel.$viewValue._attachments = data.attachments;
                                if(scope.uploadCallback) {
                                    scope.uploadCallback(data);
                                }
                            });
                        });
                    }
                });
            },
            templateUrl: 'partials/openresa/recurrente_reservation_directive.html'
        };
    }

    /**
    * @ngdoc directive
    * @name swif.ui:downloadAttachment
    * @module swif.ui
    * @restrict E
    * @description provide a download link
    * @usage
    * <download-attachment ng-model="attachment.id">
        {{attachment.datas_fname}}
      </download-attachment>
    **/
    function downloadAttachment(swif) {
        'ngInject';
        return {
            restrict: 'E',
            transclude: true,
            require: 'ngModel',
            scope: {
                mode: '@?'
            },
            link: function (scope, attribute, attrs, ngModel) {
                ngModel.$render = function () {
                    scope.reportId = ngModel.$viewValue;
                };
                scope.currentSession = swif.settings.get('token');
            },
            templateUrl: 'partials/ui/download_attachment.html'
        };
    }

    /**
    * @ngdoc directive
    * @name swif.ui:swifPrimaryAttachmentActions
    * @module swif.ui
    * @restrict E
    * @description
    * @usage
        <swif-primary-attachment-actions
            style="white-space:nowrap"
            ng-model="attachment"
            item="model"
            mode="workflow"
            ></swif-primary-attachment-actions>
    **/
    function swifPrimaryAttachmentActions(swif) {
        return {
            restrict: 'E',
            transclude: true,
            require: 'ngModel',
            scope: {
                mode: '@?',
                item: '=?'
            },
            link: function (scope, attribute, attrs, ngModel) {
                scope.model = {};
                ngModel.$render = function () {
                    scope.model.attachment = ngModel.$viewValue;
                };
                scope.preValidate = function (data) {
                    if (data.action.id === 'edit') {
                        data.model._editmode = true;
                        swif.action.updateActions(data.model);
                    }
                    return true;
                };
                scope.callback = function (error, data) {
                    if (error) {
                        return;
                    }
                    if (data.result && scope.item && data.action.id === 'delete') {
                        var index;
                        if (scope.item._attachments) {
                            index = scope.item._attachments.indexOf(scope.model.attachment);
                            if (index !== -1) {
                                scope.item._attachments.splice(index, 1);
                                swif.message.addInfo('Item has been deleted successfully');
                            }
                        }
                        if (scope.item._attachments_img) {
                            index = scope.item._attachments_img.indexOf(scope.model.attachment);
                            if (index !== -1) {
                                scope.item._attachments_img.splice(index, 1);
                            }
                        }
                        if (scope.item.attachment_count) {
                            scope.item.attachment_count = scope.item.attachment_count - 1;
                        }
                    }
                    if (data.action.id === 'save') {
                        data.model._editmode = false;
                        swif.action.updateActions(data.model);
                    }
                };

            },
            template: '<div><swif-actions type="attachment" category="primary" mode="{{mode}}" pre-validate="preValidate" callback="callback" ng-model="model.attachment"></swif-actions></div>'
        };
    }



})();
